module.exports = __webpack_public_path__ + "static/media/Inbal_Padowicz.34c4bcf0.png";